
export const GeneralCsvReportConstant = {
    Table: {
        REPORT_TYPE: "Report",
        PRINTER: "Printer",
        FILE_LOCATION: "File Location",
        OPS_LINE: "Ops Line",
        MONTH: "Month",
        YEAR: "Year",
        DOC_DATE_FROM: "Doc Date (From)",
        DOC_DATE_TO: "Doc Date (To)",
        INCLUDE_NON_VAT: "Search with non-VAT",
        CUSTOMER_TYPE: "Customer Type",
        EXPORT_TYPE: "Export Type",
    },
    Title: {
        TITLE: "General CSV Report",
        PDF: "PDF",
        CSV: "CSV",
        RTF: "RTF",
    },
}
